import * as React from 'react';

function ElectronicDoIcon(props) {
  return (
    <svg
      id='Group_1065'
      data-name='Group 1065'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width={80.978}
      height={72.36}
      viewBox='0 0 80.978 72.36'
      {...props}
    >
      <defs>
        <clipPath id='clip-path'>
          <rect
            id='Rectangle_201'
            data-name='Rectangle 201'
            width={80.978}
            height={72.36}
            fill='#fff'
          />
        </clipPath>
      </defs>
      <g id='Group_1064' data-name='Group 1064' clipPath='url(#clip-path)'>
        <path
          id='Path_602'
          data-name='Path 602'
          d='M8.76,30.573c.941-2.993,1.608-5.924,2.763-8.648a36.19,36.19,0,0,1,67.93,24.64c-.373,1.3-.9,1.472-2.124,1.155-9.544-2.465-19.106-4.863-28.663-7.277-.182-.046-.375-.045-.961-.11l4.6,7.057L0,33.1l.065-.38H35.939l-2.69-3.65H63.237a18.013,18.013,0,0,0-.733-1.828C58.474,19.91,52.293,16,43.9,16.37c-8.255.361-14.13,4.646-17.405,12.212-.749,1.731-1.555,2.247-3.364,2.185-4.3-.146-8.612-.045-12.919-.052-.336,0-.671-.063-1.454-.143'
          transform='translate(0 0)'
          fill='#fff'
        />
        <path
          id='Path_603'
          data-name='Path 603'
          d='M83.406,145.1l-5.024-6.361-1.22.9a19.581,19.581,0,0,1-11.281,3.99,19.984,19.984,0,0,1-19.122-12.509c-.231-.539-.67-1.244-1.153-1.382-5.377-1.541-10.782-2.985-16.332-4.5-.105,11.38,7.269,26.078,22.634,32.21,13.791,5.5,28.892,1.278,36.414-6.132L83.406,145.1'
          transform='translate(-20.476 -87.604)'
          fill='#fff'
        />
      </g>
    </svg>
  );
}
export default ElectronicDoIcon;
